import * as React from "react"
import { Box } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { mainSiteFormFilters } from "../../@signals"


export default function actionsColumn(onRemove) {
    return {
        name: '', label: 'Actions',
        options: {
            headerAlign: 'center',
            filter: false,
            sort: false,
            customBodyRowRenderLite: (_, row) => <Box display="flex" justifyContent="center" gap={3}>
                <IconSeeker
                    icon="pen"
                    tooltip="Change this market's main site"
                    sx={{ fontSize: '1rem', cursor: 'pointer' }}
                    onClick={() => mainSiteFormFilters.value = {
                        country: row.country,
                        siteID: row.siteID,
                        siteName: row.siteName
                    }}
                />
                <IconSeeker
                    icon="trash"
                    tooltip="Stop using a main site for this market"
                    sx={{ fontSize: '1rem', cursor: 'pointer' }}
                    onClick={() => onRemove(row)}
                />
            </Box>
        }
    }
}
